var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix card-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("span", { staticClass: "header-title" }, [
                _vm._v("线下点餐配置"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "refresh-btn",
                  attrs: {
                    type: "primary",
                    icon: "el-icon-refresh",
                    size: "small",
                    loading: _vm.refreshLoading,
                  },
                  on: { click: _vm.refreshCurrentTab },
                },
                [_vm._v("\n        刷新\n      ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tabs",
            {
              staticClass: "config-tabs",
              attrs: { type: "border-card" },
              on: { "tab-click": _vm.handleTabClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "通用配置", name: "general" } },
                [_c("general-config", { ref: "generalConfig" })],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "供应商-花喜", name: "flowerJoy" } },
                [_c("flower-joy-config", { ref: "flowerJoyConfig" })],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "供应商-乐享汇", name: "joyShare" } },
                [_c("joy-share-config", { ref: "joyShareConfig" })],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }